import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ConnectionStatus } from '../../../../model/connection-status';
import { LogService } from '../../logging/log.service';

@Injectable({
    providedIn: 'root'
})
export class ServerMonitorService {
    LOG_SOURCE = 'ServerMonitorService';

    private readonly offlineSubject = new Subject<boolean>();
    offline$: Observable<boolean> = this.offlineSubject.asObservable();

    constructor(private readonly logService: LogService) {}

    updateConnectionStatus(connectionStatus: ConnectionStatus) {
        this.logService.info(this.LOG_SOURCE, 'Server connection status update', { connectionStatus });
        this.offlineSubject.next(connectionStatus === ConnectionStatus.Offline);
    }
}
